import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../../lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, type, iconLeft, iconRight, ...props }, ref) => {
  return (
    <div
      className={cn(
        'input-base flex items-center',
        'has-disabled:cursor-not-allowed has-disabled:opacity-50 [&>span]:shrink-0 [&>span]:text-muted-foreground',
        className,
      )}
    >
      {iconLeft != null ? iconLeft : null}
      <input
        ref={ref}
        type={type}
        className={cn(
          'min-w-0 flex-1 bg-transparent text-base text-foreground leading-body',
          'file:border-0 file:bg-transparent file:font-medium file:text-sm',
          'placeholder:text-subtle-foreground',
          'focus-visible:outline-none',
          'disabled:cursor-not-allowed',
        )}
        {...props}
      />
      {iconRight != null ? iconRight : null}
    </div>
  );
});
Input.displayName = 'Input';

export type { InputProps };
export { Input };
